import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getGlAccountsClosingReq = (action) => {
    const { societyId, ...params } = action?.data || {};
    const url = apiEndpoints.GET_GL_ACCOUNTS_CLOSING_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params });
}

export const createAccountsClosingReq = (action) => {
    const { onSuccess, ...payload } = action?.data || {};
    return axiosInstance.post(apiEndpoints.CREATE_ACCOUNTS_CLOSING_API, payload);
}
